package fr.frux.feature.map.regime

import fr.frux.core.common.logging.Logger
import fr.frux.shared.domain.model.ClusterPyramid
import fr.frux.shared.domain.repository.ClusterPyramidRepository
import kotlinx.coroutines.CoroutineScope
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.StateFlow
import kotlinx.coroutines.flow.asStateFlow
import kotlinx.coroutines.launch
import kotlin.time.Duration

/**
 * Pyramide de regroupements de la carte (#622, ADR 0039), sortie de `MapViewModel` (ratchet
 * detekt `LargeClass`). Donnee publique, independante du compte : [scope] est celui du ViewModel
 * entier, pas celui de l'utilisateur, pour qu'un changement de compte ne la recharge pas.
 */
internal class MapRegimeController(
    private val repository: ClusterPyramidRepository?,
    private val embedded: suspend () -> String?,
    private val scope: CoroutineScope,
    private val enabled: Boolean,
) {
    private val fallback = MutableStateFlow<ClusterPyramid?>(null)

    /** Null sans repository (tests, plateforme sans pyramide) : la carte reste sur le lot detaille. */
    val pyramid: StateFlow<ClusterPyramid?> = repository?.pyramid ?: fallback.asStateFlow()

    /**
     * Copie locale ou embarquee d'abord, puis revalidation immediate. Dans la meme coroutine et dans
     * cet ordre : le repository tient un seul verrou pour les deux, deux coroutines se le
     * disputeraient et la revalidation pourrait passer avant toute copie.
     */
    fun start() {
        // Aperçu éteint : charger lirait 1,3 Mo et le réécrirait (localStorage partagé avec la session
        // sur le web) pour une pyramide que personne ne voit. Le lot 3 retire ce garde avec le drapeau.
        if (!enabled) return
        val repository = repository ?: return
        scope.launch {
            repository.load(embedded)
            repository.revalidate(Duration.ZERO).onFailure {
                // Hors ligne c'est attendu, donc pas d'erreur remontee : la copie chargee reste servie.
                Logger.i(TAG, "Revalidation de la pyramide en echec : ${it.message}")
            }
        }
    }

    private companion object {
        const val TAG = "MapRegime"
    }
}
